
export const loadFAQ = (document: Document) => {
  const elements = document.querySelectorAll("[data-menu]");
  for (let index = 0; index < elements.length; index++) {

    const main = elements[index];
    main.addEventListener("click", function () {
      const element = main.parentElement.parentElement;
      const indicators = main.querySelectorAll("img");
      const child = element.querySelector(".menu");
      const content = element.querySelector(".mainHeading>div>h3");

      content.classList.toggle("font-bold");
      child.classList.toggle("hidden");
      indicators[0].classList.toggle("rotate-180");
    });
  }
}
